import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAffiliateLink } from '../../../features/library/libraryActions';
import LoadingComponent from '../../layout/LoadingComponent';

export default function RedirectToPage({ match }) {
  const slug = match.params.slug;
  const dispatch = useDispatch();
  const { redirect_url } = useSelector((state) => state.library);
  const { loading } = useSelector((state) => state.async);

  useEffect(() => {
    dispatch(fetchAffiliateLink(slug));
  }, [dispatch, slug]);

  if (loading)
    return <LoadingComponent content='Finding the correct page...' />;

  return redirect_url ? (
    window.location.replace(redirect_url)
  ) : (
    <LoadingComponent />
  );
}
